<template>
  <v-card class="ma-1">
    <v-overlay :persistent="true" contained class="align-center justify-center" v-model="isShowLoading">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>

    <v-overlay :persistent="true" contained v-model="isStopped"></v-overlay>

    <v-card-item class="py-1">
      <v-card-subtitle class="pb-2 text-right">
        {{ time }}
      </v-card-subtitle>
      <v-card-title class="text-subtitle-1">
        {{ name }}
      </v-card-title>
    </v-card-item>

    <v-card-text class="pb-1">
      <div class="text-right text-h5">
        <span>{{ altValues ? altValues[value] : value }}</span>
        <span class="ms-1">{{ unit }}</span>
      </div>

      <v-alert density="compact" color="error" class="mt-2 mb-1 mx-n2 text-truncate" v-if="alarmMessage !== ''">
        {{ alarmMessage }}
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from 'vue';

export default defineComponent({
  name: 'LatestTile',
  props: {
    loading: { type: Boolean, default: true },

    name: { type: String, default: '-' },

    altValues: { type: Object },

    unit: { type: String },

    alarms: {
      type: Object,

      default(/* rawProps */) {
        return {
          upper: [],
          lower: []
        }
      }
    },

    intervalMinutes: { type: Number },

    time: { type: String, default: '-' },
    value: { type: String, default: '-' }
  },

  setup(props) {

    const isShowLoading = ref(props.loading);

    const isStopped = ref(false);

    const alarmMessage = ref('');

    onMounted(() => {

      watch(props, () => {

        isShowLoading.value = props.loading;


        if (props.intervalMinutes && props.time !== '-') {

          const timestamp_ms = Date.parse(props.time);
          const now_ms = new Date().getTime();

          // 計測からアップロード完了までの遅延を考慮して60秒のマージンを設ける
          if (timestamp_ms + (props.intervalMinutes * 60 * 1000) + 60000 < now_ms) {
            isStopped.value = true;
          } else {
            isStopped.value = false;
          }

        }


        alarmMessage.value = '';

        const val = parseFloat(props.value);
        if (isNaN(val)) {
          return;
        }

        for (let i = 0; i < props.alarms.upper.length; i++) {
          if (props.alarms.upper[i].value <= val) {
            alarmMessage.value = props.alarms.upper[i].msg;
            return;
          }
        }

        for (let i = 0; i < props.alarms.lower.length; i++) {
          if (val <= props.alarms.lower[i].value) {
            alarmMessage.value = props.alarms.lower[i].msg;
            return;
          }
        }

      });

    });

    return {
      isShowLoading,

      isStopped,

      alarmMessage
    }
  }
});
</script>
